"use client";

import { Drawer } from "flowbite-react";
import { Fragment } from "react";
import { NoDataFound } from "../../../components/table/tableComponent";

const BottomDrawer = ({
  isOpen,
  setIsOpen,
  isLeft = false,
  size,
  title,
  classname,
  children,
  classNames,
  position = "bottom",
  custom = false,
  close = () => null,
}) => {
  const handleClose = () => {
    if (custom) {
      close();
    } else {
      setIsOpen(false);
    }
  };

  return (
    <Fragment>
      <Drawer
        open={isOpen}
        onClose={handleClose}
        className={`${
          isLeft ? "left-2 right-auto top-2" : " left-auto right-2 top-2"
        } ${classNames}
        h-[calc(100vh-.5rem)] ${
          size === "full"
            ? "w-[calc(100vw-20px)]"
            : size === "md"
            ? "w-[800px]"
            : "w-[500px]"
        } rounded-t-md !p-0
         `}
        position={position}
      >
        <Drawer.Header
          className="border-b px-4 h-14 flex items-center !mb-0 sticky top-0 bg-white z-10"
          title={title ? title : "No Title"}
          titleIcon={() => <></>}
        />
        <Drawer.Items className={classname ? "p-0 " : "p-4"}>
          {children ? (
            children
          ) : (
            <div className="flex flexCenter w-full h-full">
              <NoDataFound asTableCell={false} />
            </div>
          )}
        </Drawer.Items>
      </Drawer>
    </Fragment>
  );
};

export default BottomDrawer;
